export default __webpack_public_path__ + "static/media/거래내역.7cc619e1.jpg";